import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Select from 'react-select';
import API from "../../config/api";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const QuestionsView = () => {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState({
    video_id: 1,
    video: {}, // Initialize as empty object or appropriate initial state
    episodes: [],
    tags: [],
    // options : [
    //   { value: 'chocolate', label: 'Chocolate' },
    //   { value: 'strawberry', label: 'Strawberry' },
    //   { value: 'vanilla', label: 'Vanilla' }
    // ]
  });

  useEffect(() => {
    // getParam logic is replaced by useSearchParams
    const id = searchParams.get("id");
    if (id) {
      getOneVideo(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const getOneVideo = async (id) => {
    try {
      let query = `video_id=${id}`
      let results = await API.getOneVideo(query);

      let data = results.data;
      console.log(data)
      setState(prev => ({
        ...prev,
        video: data.video,
        episodes: data.episode,
        tags: data.tag,
        video_id: id
      }));

    } catch (error) {
      console.log(error)
    }
  }

  // Mapping tags for Select component
  const mappedTags = state.tags.map(item => ({
    value: item.name_en,
    label: item.name_en
  }));

  return (
    <div className="col-12">
      <ToastContainer />
      <div className="card"> {/* Wrapped in a div/card container like original form */}
        <form className="card">
          <h4 className="card-title"><strong>Video Information</strong></h4>
          <div className="card-title row">

            <div className="col-md-6">
              <div className="form-group">
                <label className="require" htmlFor="input-required">Title Kh</label>
                <input type="text" className="form-control" id="input-required" value={state.video.title_kh || ''} readOnly />
              </div>
              <div className="form-group">
                <label className="require" htmlFor="input-required">Description Kh </label>
                <textarea type="text" className="form-control" id="input-required" value={state.video.description_kh || ''} readOnly />
              </div>

              <div className="form-group">
                <label> Totla price</label>
                <small className="sidetitle">E.g. $ 999.99</small>
                <input type="text" className="form-control" data-format="$ {{999}}.{{99}}" value={"$ " + (state.video.total_price || '')} readOnly />
              </div>
              <div className="form-group">
                <label>Release date</label>
                {/* <input className="form-control" type="date" value={this.state.video.created_at} /> */}
                <input className="form-control" type="datetime-local" value={state.video.created_at || ''} readOnly />
              </div>
              <div className="form-group">
                <label> Totla rating</label>
                <input type="text" className="form-control" data-format="$ {{999}}.{{99}}" value={state.video.total_rating || ''} readOnly />
              </div>
              <div className="form-group">
                <label>Thumbnail</label>
                <div className="input-group file-group">
                  <img className='h-300px w-fullscreen' src={state.video.thumbnail_url} alt="..." />
                  {/* <input type="text" class="form-control file-value" placeholder="Choose file..." readonly /> */}
                  {/* <input type="file" multiple /> */}
                  <span className="input-group-append">
                    {/* <button class="btn btn-light file-browser" type="button"><i class="fa fa-upload"></i></button> */}
                  </span>
                </div>
              </div>
            </div>



            <div className="col-md-6">
              <div className="form-group">
                <label>Title En</label>
                <input className="form-control" type="text" value={state.video.title_en || ''} readOnly />
              </div>
              <div className="form-group">
                <label className="require" htmlFor="input-required">Description En</label>
                <textarea type="text" className="form-control" id="input-required" value={state.video.description_en || ''} readOnly />
              </div>


              <div className="form-group">
                <label>Discount</label>
                <small className="sidetitle">E.g. %25.46</small>
                <input type="text" className="form-control" data-format="%{{99}}.{{99}}" value={(state.video.discount || '') + ' %'} readOnly />
              </div>


              <div className="form-group">
                {/* <label for="inputState" className="col-form-label">Tag</label> */}
                <label>Tag</label>
                <Select
                  // defaultValue={[this.state.options[2], this.state.options[3]]}
                  value={mappedTags}
                  isMulti
                  name="colors"
                  // options={this.state.options}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  isDisabled
                />
              </div>
              <div className="form-group">
                <label>Rating</label>
                <input className="form-control" type="text" value={state.video.rating || ''} readOnly />
              </div>
              <div className="form-group">
                <label>Preview Video</label>
                <div className="card">
                  <div className="embed-responsive embed-responsive-16by9 h-300px">
                    <iframe src={state.video.preview_video_url} title="video1080" frameBorder="0" allowFullScreen=""></iframe>
                  </div>


                  <div className="card-body py-12">
                    <div className="gap-items-4">
                      <a className="text-lighter hover-light" href="/">
                        <i className="fa fa-thumbs-up mr-1"></i> 196
                      </a>
                      <a className="text-lighter hover-light" href="/">
                        <i className="fa fa-comment mr-1"></i> 24
                      </a>
                      <a className="text-lighter hover-light" href="/">
                        <i className="fa fa-share-alt mr-1"></i> 3
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
          </div>
        </form>
        {
          state.episodes.map((episode, index) => {
            return <form className="card" key={index}>
              <h4 className="card-title"><strong>Episode {index + 1}</strong></h4>
              <div className="card-body row">

                <div className="col-md-6">
                  <div className="form-group">
                    <label className="require" htmlFor="input-required">Title Kh</label>
                    <input type="text" className="form-control" id="input-required" value={episode.title_kh || ''} readOnly />
                  </div>
                  <div className="form-group">
                    <label className="require" htmlFor="input-required">Description Kh</label>
                    <textarea type="text" className="form-control" id="input-required" value={episode.description_kh || ''} readOnly />
                  </div>

                  <div className="form-group">
                    <label> Totla price</label>
                    <small className="sidetitle">E.g. $ 999.99</small>
                    <input type="text" className="form-control" data-format="$ {{999}}.{{99}}" value={"$ " + (episode.price || '')} readOnly />
                  </div>
                  <div className="form-group">
                    <label>Release date</label>
                    {/* <input className="form-control" type="date" value={this.state.video.created_at} /> */}
                    <input className="form-control" type="datetime-local" value={episode.created_at || ''} readOnly />
                  </div>
                  <div className="form-group">
                    <label>Thumbnail</label>
                    <div className="input-group file-group">
                      <img className='h-300px w-fullscreen' src={episode.thumbnail_url} alt="..." />
                      {/* <input type="text" class="form-control file-value" placeholder="Choose file..." readonly /> */}
                      {/* <input type="file" multiple /> */}
                      <span className="input-group-append">
                        {/* <button class="btn btn-light file-browser" type="button"><i class="fa fa-upload"></i></button> */}
                      </span>
                    </div>
                  </div>
                </div>


                <div className="col-md-6">
                  <div className="form-group">
                    <label>Title En</label>
                    <input className="form-control" type="text" value={episode.title_en || ''} readOnly />
                  </div>
                  <div className="form-group">
                    <label className="require" htmlFor="input-required">Description En</label>
                    <textarea type="text" className="form-control" id="input-required" value={episode.description_en || ''} readOnly />
                  </div>
                  <div className="form-group">
                    <label>Discount</label>
                    <small className="sidetitle">E.g. %25.46</small>
                    <input type="text" className="form-control" data-format="%{{99}}.{{99}}" value={(episode.discount || '') + ' %'} readOnly />
                  </div>
                  <div className="form-group">
                    <label>Number view</label>
                    <input className="form-control" type="text" value={episode.nb_views || ''} readOnly />
                  </div>
                </div>
                <div className="card-body row">
                  <div className="col-12">
                    <div className="form-group">
                      <h6 className="mb-1">Episode</h6>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Video 720</label>
                      <div className="card">
                        <div className="embed-responsive embed-responsive-16by9">
                          <iframe src={episode.video_url} title="video1080" frameBorder="0" allowFullScreen=""></iframe>
                        </div>


                        <div className="card-body py-12">
                          <div className="gap-items-4">
                            <a className="text-lighter hover-light" href="/">
                              <i className="fa fa-thumbs-up mr-1"></i> 196
                            </a>
                            <a className="text-lighter hover-light" href="/">
                              <i className="fa fa-comment mr-1"></i> 24
                            </a>
                            <a className="text-lighter hover-light" href="/">
                              <i className="fa fa-share-alt mr-1"></i> 3
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Video 1080</label>
                      <div className="card">
                        <div className="embed-responsive embed-responsive-16by9">
                          <iframe src={episode.video_url} title="video1080" frameBorder="0" allowFullScreen=""></iframe>
                        </div>
                        <div className="card-body py-12">
                          <div className="gap-items-4">
                            <a className="text-lighter hover-light" href="/">
                              <i className="fa fa-thumbs-up mr-1"></i> 196
                            </a>
                            <a className="text-lighter hover-light" href="/">
                              <i className="fa fa-comment mr-1"></i> 24
                            </a>
                            <a className="text-lighter hover-light" href="/">
                              <i className="fa fa-share-alt mr-1"></i> 3
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Video 4k</label>

                      <div className="card">
                        <div className="embed-responsive embed-responsive-16by9">
                          <iframe src={episode.video_url} title="video1080" frameBorder="0" allowFullScreen=""></iframe>
                        </div>


                        <div className="card-body py-12">
                          <div className="gap-items-4">
                            <a className="text-lighter hover-light" href="/">
                              <i className="fa fa-thumbs-up mr-1"></i> 196
                            </a>
                            <a className="text-lighter hover-light" href="/">
                              <i className="fa fa-comment mr-1"></i> 24
                            </a>
                            <a className="text-lighter hover-light" href="/">
                              <i className="fa fa-share-alt mr-1"></i> 3
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          })
        }
        <footer className="card-footer text-right">
          {/* <Link to="/videoindex"><button className="btn btn-secondary" type="reset">Cancel</button></Link> */}
          <Link to="/videoindex" className="btn btn-secondary" >Back</Link>
        </footer>
      </div>
    </div>
  );
}

export default QuestionsView;
